import React from "react";
import "./style.scss";

const Dot = ({active, setActive, index}) => (
  <span
    className={`dot ${active ? "active-dot" : ""}`}
    onClick={setActive.bind(this, index)}
  />
);

const Dots = ({slides, activeSlide, setActive}) => (
  <div className="dots-container">
    {slides.map((slide, i) => (
      <Dot key={i} active={activeSlide === i} setActive={setActive} index={i} />
    ))}
  </div>
);

export default Dots;
